export type Colors = {
  primary: string;
  contrast: string;
  background: string;
  background02: string;
  background03: string;
  background04: string;
  background05: string;
  link: string;
  success: string;
  error: string;
  warning: string;
};

export const lightColors: Colors = {
  primary: '#302B3C',
  contrast: '#ffffff',
  background: '#FBFBFD',
  background02: '#9D9D9D',
  background03: '#D8D8D8',
  background04: '#F2F4FA',
  background05: '#FBFBFD',
  link: '#0085FF',
  success: '#6BC10E',
  error: '#FF475D',
  warning: '#FFB600',
};

export const darkColors: Colors = {
  primary: '#c7c3bb',
  contrast: '#181a1b',
  background: '#FBFBFD',
  background02: '#a4a4a4',
  background03: '#D8D8D8',
  background04: '#262f4b',
  background05: '#FBFBFD',
  link: '#33a5ff',
  success: '#6BC10E',
  error: '#FF475D',
  warning: '#FFB600',
};
